import { useState } from 'react';
import {
  InsightsTimeOptions,
  useMonthlyReportsBySourceQuery,
  useReportCountQuery,
  useReportYearsQuery,
  useReportsByCategoryQuery,
  useReportsByDepartmentQuery,
  useReportsByStatusQuery,
} from 'src/graphql';

export const useInsightsV1 = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isInUse, setIsInUse] = useState<InsightsTimeOptions>(
    InsightsTimeOptions.All,
  );
  const { data: years } = useReportYearsQuery();
  const [currentYear, setCurrentYear] = useState<number | undefined>(undefined);
  const { data: reports } = useReportCountQuery({
    input: { type: isInUse, year: currentYear },
  });
  const [open, setOpen] = useState(false);
  const { data: dataForAreaChart } = useMonthlyReportsBySourceQuery({
    input: { type: isInUse, year: currentYear },
  });
  const { data: dataForPieChart } = useReportsByStatusQuery({
    input: { type: isInUse, year: currentYear },
  });
  const { data: dataForRadarChart } = useReportsByDepartmentQuery({
    input: { type: isInUse, year: currentYear },
  });
  const { data: dataForBarChart } = useReportsByCategoryQuery({
    input: { type: isInUse, year: currentYear },
  });

  return {
    activeIndex,
    setActiveIndex,
    totalNumberOfreports: reports?.reportCount ?? 0,
    isInUse,
    setIsInUse,
    years,
    currentYear,
    setCurrentYear,
    open,
    setOpen,
    dataForAreaChart,
    dataForPieChart,
    dataForRadarChart,
    dataForBarChart,
  };
};
